export default __webpack_public_path__ + "static/media/eb-blk-banner-2.b080a544.jpg";